import React from 'react';
import { connect } from 'react-redux';
import { addToCart, updateCart } from '../../utility/utility-actions';

import '../css/xsell-modal.less';

class CheckboxCTA extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			adding: false,
			removing: false,
		}
	}

	addAndRemove = (product) => {
		const { added, addToCart, updateCart, cartItems, handleAddandRemove, xsellTemplate, baseProductSku, ctaMetrics } = this.props;
		if (!added) {
			this.setState({ adding: true }, () => {
				addToCart(product, 1, baseProductSku, xsellTemplate, ctaMetrics).then(() => {
					handleAddandRemove('add', product.sku);
					this.setState({ adding: false })
				}).catch((e) => this.setState({ adding: false }));
			})
		} else {
			this.setState({ removing: true }, () => {
				const itemToRemove = cartItems.filter(item => item.pNum === product.sku)[0] || {};
				const quantityToRemove = (itemToRemove || {}).qty - 1 || 0;
				updateCart(itemToRemove, quantityToRemove).then(() => {
					handleAddandRemove('remove', product.sku)
					this.setState({ removing: false });
				}).catch((e) => this.setState({ removing: false }));
			})
		}
	}

	getCTAText = () => {
		const { product, added } = this.props;
		const { adding, removing } = this.state;
		let cta = ''
		if (product.instock === false) {
			cta = 'Out of stock';
		} else if (removing) {
			cta = 'Removing'; 
		} else if (added) {
			cta = 'Added to cart';
		} else if (adding) {
			cta = 'Adding';
		} else {
			cta = 'Add to cart';
		}
		return cta;
	}

	render() {
		const { product } = this.props;
        const { added } = this.props;
        return (
            <div className={`checkbox-a2c-wrapper`} onClick={() => this.addAndRemove(product)}>
                <input className="checkbox-a2c" type="checkbox" checked={added} readOnly />
                <span className={product.instock === false ? 'oos checkmark' : 'checkmark'}></span>
                <span className="cta">{this.getCTAText()}</span>
            </div>
        )
	}
}

const mapStateToProps = (state) => ({
    cartItems: state.cartInfo.items,
});

const mapDispatchToProps = dispatch => {
	return {
        addToCart: (product, quantity, baseProductSku, xsellType, metricParams) => dispatch(addToCart(product, quantity, false, null, {}, baseProductSku, xsellType, metricParams)),
        updateCart: (cartItem, curQty) => dispatch(updateCart(cartItem, curQty))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxCTA);